import { CHANGE_DISTANCE_STORAGE_KEY } from 'src/modules/changeDistance/constants';

export type StoredChangeDistanceRequest = {
  token: string;
  toDistanceId: number | null;
};

export const readChangeDistanceRequest = (): StoredChangeDistanceRequest | null => {
  const stored = sessionStorage.getItem(CHANGE_DISTANCE_STORAGE_KEY);

  if (!stored) {
    return null;
  }

  try {
    const parsed = JSON.parse(stored);

    return parsed?.token ? parsed : null;
  } catch (error) {
    return null;
  }
};

export const writeChangeDistanceRequest = (request: StoredChangeDistanceRequest): void => {
  sessionStorage.setItem(CHANGE_DISTANCE_STORAGE_KEY, JSON.stringify(request));
};

export const clearChangeDistanceRequest = (): void => {
  sessionStorage.removeItem(CHANGE_DISTANCE_STORAGE_KEY);
};
